"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _semanticUiReact = require("semantic-ui-react");
var _reactGa = _interopRequireDefault(require("react-ga"));
var _MobileMenu = _interopRequireDefault(require("./components/MobileMenu"));
var _MenuItems = _interopRequireDefault(require("./components/MenuItems"));
var _InternalLink = _interopRequireDefault(require("../../atoms/InternalLink"));
require("./mobile.css");
require("./navigation.css");
function _createSuper(Derived) {
  return function () {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
      result;
    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function handleScroll(event) {
  var _event$srcElement$doc = event.srcElement.documentElement,
    scrollTop = _event$srcElement$doc.scrollTop,
    scrollHeight = _event$srcElement$doc.scrollHeight;
  var progress = scrollTop / (scrollHeight - window.innerHeight) * 100;
  var roundedProgress = Math.round(progress);
  if ([25, 50, 75, 100].includes(roundedProgress)) {
    _reactGa["default"].event({
      category: 'Page Scroll',
      action: 'Scroll',
      label: window.location.pathname,
      value: "".concat(roundedProgress, "%")
    });
  }
}
var Navigation = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Navigation, _React$Component);
  var _super = _createSuper(Navigation);
  function Navigation() {
    (0, _classCallCheck2["default"])(this, Navigation);
    return _super.apply(this, arguments);
  }
  (0, _createClass2["default"])(Navigation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('scroll', function (event) {
        handleScroll(event);
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.addEventListener('scroll', function (event) {
        handleScroll(event);
      });
    }
  }, {
    key: "getWidthsProps",
    value: function getWidthsProps() {
      var links = this.props.links;
      var count = this.logoHasOwnRow() ? links.length : links.length + 1;
      return this.isEvenSpacing() ? {
        widths: count
      } : {};
    }
  }, {
    key: "getContainerClassNames",
    value: function getContainerClassNames() {
      var _this$props = this.props,
        fixed = _this$props.fixed,
        backgroundColor = _this$props.backgroundColor; // create class names

      var classNames = 'navigation-container';
      if (fixed) {
        classNames += ' navigation-container-top-fixed';
      } else {
        classNames += ' navigation-container-top';
      } // colors

      if (backgroundColor === 'primary') {
        classNames += ' navigation-primary-background';
      } else if (backgroundColor === 'secondary') {
        classNames += ' navigation-secondary-background';
      }
      return classNames;
    }
  }, {
    key: "getContainerStyle",
    value: function getContainerStyle() {
      var backgroundColor = this.props.backgroundColor;
      var additionalStyle = backgroundColor !== 'primary' && backgroundColor !== 'none' ? {
        backgroundColor: backgroundColor,
        color: 'white !important'
      } : {};
      return additionalStyle;
    }
  }, {
    key: "getPrimaryContent",
    value: function getPrimaryContent(mobile) {
      var _this$props2 = this.props,
        header = _this$props2.header,
        logo = _this$props2.logo,
        internalLinkComponent = _this$props2.internalLinkComponent;
      var content = null;
      var wrapAsMenuItem = false;
      if (logo) {
        content = /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Image, {
          height: mobile ? 50 : 60,
          src: logo,
          centered: true
        });
      } else if (mobile) {
        content = /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
          as: "h3",
          style: {
            verticalAlign: 'middle',
            textAlign: 'center'
          }
        }, header);
      } else {
        content = this.logoHasOwnRow() ? /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
          as: "h2",
          style: {
            textAlign: 'center',
            marginTop: 0
          }
        }, header) : /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
          as: "h3",
          style: {
            verticalAlign: 'middle',
            textAlign: 'center'
          }
        }, header);
        wrapAsMenuItem = !this.logoHasOwnRow();
      }
      var primaryContent = /*#__PURE__*/_react["default"].createElement(_InternalLink["default"], {
        gatsbyLink: true,
        to: "/",
        as: internalLinkComponent
      }, content);
      return wrapAsMenuItem ? /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Menu.Item, {
        header: true,
        style: {
          textAlign: 'center'
        }
      }, primaryContent) : primaryContent;
    }
  }, {
    key: "isEvenSpacing",
    value: function isEvenSpacing() {
      var _this$props3 = this.props,
        evenSpacing = _this$props3.evenSpacing,
        primaryContentPosition = _this$props3.primaryContentPosition,
        links = _this$props3.links,
        logo = _this$props3.logo,
        header = _this$props3.header;
      var isMiddleWithEvenLinks = primaryContentPosition === 'middle' && links.length % 2 === 0;
      var noHeaderOrLogo = header.length === 0 && logo.length === 0;
      return evenSpacing && (isMiddleWithEvenLinks || primaryContentPosition === 'top') || noHeaderOrLogo;
    }
  }, {
    key: "logoHasOwnRow",
    value: function logoHasOwnRow() {
      var primaryContentPosition = this.props.primaryContentPosition;
      return primaryContentPosition === 'top';
    }
  }, {
    key: "renderMenuItems",
    value: function renderMenuItems() {
      var _this$props4 = this.props,
        links = _this$props4.links,
        linksAs = _this$props4.linksAs,
        primaryContentPosition = _this$props4.primaryContentPosition,
        header = _this$props4.header,
        logo = _this$props4.logo,
        backgroundColor = _this$props4.backgroundColor,
        internalLinkComponent = _this$props4.internalLinkComponent,
        className = _this$props4.className;
      if (primaryContentPosition === 'top' || !header && !logo) {
        return /*#__PURE__*/_react["default"].createElement(_MenuItems["default"], {
          backgroundColor: backgroundColor,
          linksAs: linksAs,
          links: links,
          internalLinkComponent: internalLinkComponent,
          className: className
        });
      }
      if (primaryContentPosition === 'middle' && links.length % 2 === 0) {
        var linksLength = links.length;
        var linksPivot = Math.floor(linksLength / 2);
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_MenuItems["default"], {
          backgroundColor: backgroundColor,
          internalLinkComponent: internalLinkComponent,
          linksAs: linksAs,
          links: links.slice(0, linksPivot),
          className: className
        }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Menu.Item, null, this.getPrimaryContent()), /*#__PURE__*/_react["default"].createElement(_MenuItems["default"], {
          backgroundColor: backgroundColor,
          internalLinkComponent: internalLinkComponent,
          linksAs: linksAs,
          links: links.slice(linksPivot),
          className: className
        }));
      }
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Menu.Item, null, this.getPrimaryContent()), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Menu.Menu, {
        position: "right",
        className: "fisherman-navigation-right-menu"
      }, /*#__PURE__*/_react["default"].createElement(_MenuItems["default"], {
        backgroundColor: backgroundColor,
        internalLinkComponent: internalLinkComponent,
        linksAs: linksAs,
        links: links
      })));
    }
  }, {
    key: "renderNavContainer",
    value: function renderNavContainer(child) {
      if (this.logoHasOwnRow()) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: this.getContainerStyle()
        }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Segment, {
          className: this.getContainerClassNames()
        }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Menu.Item, null, this.getPrimaryContent()), child));
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: this.getContainerClassNames(),
        style: this.getContainerStyle()
      }, child);
    }
  }, {
    key: "renderDesktopNav",
    value: function renderDesktopNav() {
      var _this$props5 = this.props,
        bordered = _this$props5.bordered,
        fixed = _this$props5.fixed;
      var menuFixed = !this.logoHasOwnRow() && fixed ? 'top' : null;
      if (this.logoHasOwnRow()) {
        return this.renderNavContainer(/*#__PURE__*/_react["default"].createElement(_semanticUiReact.Menu, (0, _extends2["default"])({
          stackable: true,
          borderless: !bordered,
          size: "massive",
          fixed: menuFixed
        }, this.getWidthsProps()), this.renderMenuItems()));
      }
      return this.renderNavContainer(/*#__PURE__*/_react["default"].createElement(_semanticUiReact.Menu, (0, _extends2["default"])({
        stackable: true,
        borderless: !bordered,
        size: "massive",
        fixed: menuFixed
      }, this.getWidthsProps()), this.renderMenuItems()));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
        linksAs = _this$props6.linksAs,
        links = _this$props6.links,
        centerMobileNavItems = _this$props6.centerMobileNavItems,
        primaryContentPosition = _this$props6.primaryContentPosition,
        backgroundColor = _this$props6.backgroundColor,
        internalLinkComponent = _this$props6.internalLinkComponent,
        invertedHamburgerButton = _this$props6.invertedHamburgerButton;
      var desktopNav = this.renderDesktopNav();
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "desktop-nav"
      }, desktopNav), /*#__PURE__*/_react["default"].createElement("div", {
        className: "mobile-nav"
      }, /*#__PURE__*/_react["default"].createElement(_MobileMenu["default"], {
        invertedHamburgerButton: invertedHamburgerButton,
        internalLinkComponent: internalLinkComponent,
        centerMobileNavItems: centerMobileNavItems,
        logo: this.getPrimaryContent(true),
        position: primaryContentPosition,
        links: links,
        linksAs: linksAs,
        className: this.getContainerClassNames(),
        backgroundColor: backgroundColor
      })));
    }
  }]);
  return Navigation;
}(_react["default"].Component);
exports["default"] = Navigation;
Navigation.propTypes = {
  links: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    pageTitle: _propTypes["default"].string.isRequired,
    slug: _propTypes["default"].string.isRequired,
    internal: _propTypes["default"].bool.isRequired,
    emphasis: _propTypes["default"].bool,
    inverted: _propTypes["default"].bool,
    as: _propTypes["default"].oneOf([_propTypes["default"].string, _propTypes["default"].element]),
    className: _propTypes["default"].string,
    disableToggle: _propTypes["default"].bool,
    dropdown: _propTypes["default"].shape({
      title: _propTypes["default"].string,
      options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
        pageTitle: _propTypes["default"].string.isRequired,
        slug: _propTypes["default"].string.isRequired,
        internal: _propTypes["default"].bool.isRequired,
        emphasis: _propTypes["default"].bool,
        inverted: _propTypes["default"].bool,
        as: _propTypes["default"].oneOf([_propTypes["default"].string, _propTypes["default"].element]),
        className: _propTypes["default"].string,
        disableToggle: _propTypes["default"].bool
      }))
    })
  })).isRequired,
  backgroundColor: _propTypes["default"].string,
  bordered: _propTypes["default"].bool,
  centerMobileNavItems: _propTypes["default"].bool,
  evenSpacing: _propTypes["default"].bool,
  fixed: _propTypes["default"].bool,
  invertedHamburgerButton: _propTypes["default"].bool,
  header: _propTypes["default"].string,
  linksAs: _propTypes["default"].oneOf(['h3', 'h4', 'h5', 'h6', 'text']),
  logo: _propTypes["default"].string,
  internalLinkComponent: _propTypes["default"].element,
  primaryContentPosition: _propTypes["default"].oneOf(['top', 'left', 'middle']),
  primaryContentCentered: _propTypes["default"].bool
};
Navigation.defaultProps = {
  backgroundColor: 'none',
  bordered: false,
  centerMobileNavItems: true,
  evenSpacing: false,
  fixed: false,
  invertedHamburgerButton: false,
  header: '',
  linksAs: 'h4',
  logo: '',
  internalLinkComponent: 'a',
  primaryContentPosition: 'left',
  primaryContentCentered: false
};
Navigation.propOptions = {
  backgroundColor: ['primary', 'none']
};
Navigation.dataPropsMap = {};